import React, { useState } from 'react';
import Header from '../component/Header';
import Sidebar from '../component/Sidebar';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import Insurance from '../component/Insurance';
import Payment from '../component/Payment';

const Wallet = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [isBalanceVisible, setIsBalanceVisible] = useState(true);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    const toggleBalanceVisibility = () => {
        setIsBalanceVisible(!isBalanceVisible);
    };

    const [isPersonalInfoVisible, setIsPersonalInfoVisible] = useState(true);
    const [isSubscriptionVisible, setIsSubscriptionVisible] = useState(false);

    const togglePersonalInfo = () => {
        setIsPersonalInfoVisible(true);
        setIsSubscriptionVisible(false);
    };

    const toggleSubscription = () => {
        setIsPersonalInfoVisible(false);
        setIsSubscriptionVisible(true);
    };

    return (
        <div className='w-full flex items-start justify-center bg-[#F9FAFB] relative'>
            {/* Sidebar with conditional rendering for mobile */}
            <div className={`${isSidebarOpen ? 'block' : 'hidden'} lg:block w-full lg:w-1/6 fixed left-0 top-0 h-full z-50`}>
                <Sidebar toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} />
            </div>

            {/* Overlay for mobile when sidebar is open */}
            {isSidebarOpen && (
                <div 
                    className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
                    onClick={toggleSidebar}
                ></div>
            )}

            <div className='flex flex-col w-full space-y-4 lg:ml-[16.67%]'>
                <div>
                     <Header isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} 
                     title='Wallet'
                     />  
                </div>

                <div className='p-4 lg:p-[30px]'>
                    <div className='w-full flex items-center justify-between'>
                        <div className='flex items-center gap-2'>
                            <p>
                                Wallet Balance: 
                            </p>

                            {isBalanceVisible ? (
                                <p>
                                    N10,000
                                </p>
                            ) : (
                                <p>******</p>
                            )}
                            
                            <button title='balance' onClick={toggleBalanceVisibility}>
                                {isBalanceVisible ? <VisibilityOutlinedIcon /> : <VisibilityOffOutlinedIcon />}
                            </button>
                        </div>

                        <div>              
                            <button className='flex gap-1 bg-[#069125] text-white font-medium py-1 px-2 items-center rounded-md text-sm md:text-base
                            md:py-2 md:px-4'>
                                <span>
                                    Fund Wallet
                                </span>
                            </button>
                       </div>
                    </div>
                    <div className='w-full flex items-center justify-between mt-4'>
                       <div className='flex gap-3 text-sm items-center md:text-base lg:gap-6'>
                            <button onClick={togglePersonalInfo} className={isPersonalInfoVisible ? 'text-[#069125] pb-1 border-b border-[#069125] font-medium' : ''}>
                            Payment
                            </button>
                            <button onClick={toggleSubscription} className={isSubscriptionVisible ? 'text-[#069125] pb-1 border-b border-[#069125] font-medium' : ''}>
                            Insurance 
                            </button>
                       </div>
                    </div>

                    {isPersonalInfoVisible && (
                        <div className='pb-96'>
                          <Payment />
                        </div>
                    )}

                    {isSubscriptionVisible && (
                        <div className=''>
                            <Insurance />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Wallet;
